// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2AXLP","selected":"Chip_selected__qc54X"};